import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import ProductRating from './ProductRating'

import './../../css/product-review.css'

export default class ProductRatingSection extends Component {
	render() {
		
		const product = this.props.product

		let clName = 'review_container'
		clName += !product.rating ? ' review_container--no_ratings' : ''

		return (
			<div className={clName}>
				{product.rating ? (
					<ProductRating rating={product.rating} />
				) : (
					<div className="review_stars">
						This product has not been rated yet!
					</div>
				)}
				
				<ul className="links">
					<li><Link className="review_link" to={`/reviews/${product.permalink}`}>Read Reviews</Link></li>
					<li><Link className="review_link" to={`/reviews/write/${product.permalink}`}>Write Review</Link></li>
				</ul>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/product/ProductRatingSection.js